{
	"refusal": {
		"not_url": "This is not a link. Paste the address of the video.",
		"not_https": "The link must start with https://.",
		"unsupported_host": "Only YouTube and Facebook video links can be shown on the portal.",
		"youtube_handle": "Paste the link of the live video itself, not the channel's @name page.",
		"no_video_id": "This link does not point to a video. Open the video and copy its address."
	},
	"platform": {
		"youtube": "Plays from YouTube.",
		"facebook": "Plays from Facebook."
	},
	"open": "Open the video",
	"opensInNewTab": "Opens in a new tab",
	"preview": "Preview",
	"hidePreview": "Hide preview",
	"previewTitle": "Video preview",
	"previewNote": "Starts muted, as on the home page.",
	"placeholder": "https://www.youtube.com/watch?v=…",
	"featured": {
		"title": "Featured video",
		"subtitle": "Plays first on the home page while it is on — for ceremonies or the studio show.",
		"readOnly": "Your role can see the featured videos but not change them.",
		"forbiddenTitle": "Admins only",
		"forbiddenBody": "Only super admins and admins can open the featured video settings.",
		"loadError": "Couldn't load the featured videos.",
		"retry": "Try again",
		"loading": "Loading featured videos…",
		"empty": "No games set up yet.",
		"link": "Video link",
		"linkHint": "A YouTube or Facebook video link.",
		"videoTitle": "Title",
		"titleHint": "{{used}} of {{max}} characters. Shown above the player.",
		"titlePlaceholder": "Opening Ceremony",
		"titleRequired": "Enter a title.",
		"titleTooLong": "{{max}} characters at most.",
		"linkRequired": "Paste a video link.",
		"enabled": "Show on the home page",
		"enabledHint": "While this is on, the video plays first on the home page.",
		"stateOn": "On the home page",
		"stateOff": "Not shown",
		"stateNone": "Not set",
		"lastChanged": "Last changed {{when}}",
		"save": "Save",
		"discard": "Discard changes",
		"pending": "Not saved yet.",
		"clean": "No changes.",
		"confirmTitle": "Save the featured video for {{games}}?",
		"confirmBodyOn": "It plays first on the home page as soon as it is saved.",
		"confirmBodyOff": "It will not be shown on the home page.",
		"reason": "Why are you making this change?",
		"reasonPlaceholder": "For example: Opening ceremony starts at 19:00",
		"saved": "Featured video saved for {{games}}.",
		"stale": "Someone else changed this featured video while you had it open. It has been reloaded with their version — check it and make your change again."
	}
}
